<template>
  <div class="bm-bd-agent">
    <div class="content">
      <div class="top-info display-flex-start">
        <div class="left">
          <img :src="imageView(currentBd.icon, 182, 182)">
        </div>
        <div class="right">
          <div class="house-manage">
            <div class="manage-name">{{currentBd.name}}</div>
            <div class="manage-state">
              <div>专属顾问</div>
            </div>
          </div>
          <div class="phone">{{currentBd.mobile}}</div>
        </div>
      </div>
      <div class="agent-tip">斑马邦赛事管家竭诚为您服务</div>
      <div class="soft-code">
        <img :src="imageView(currentBd.wx, 180, 180)">
      </div>
      <div class="tips">分享到微信，扫码添加专属顾问</div>
    </div>
    <div class="footer-box">
      <img src="../../assets/images/bmb-footer-logo.png">
    </div>
  </div>
</template>

<script>
import { ImageFormat } from '@/utils'
const bdList = [
  {
    icon: 'FiY9Wu3k3NQKTCMcmcE-ctAOPJll',
    name: '李光泽',
    mobile: '18659928276',
    desc: '不忘初心，砥砺前行。为每个赛事组织机构提供优质高效的真诚服务！',
    content: [
      '斑马邦华南区赛事合作商务主管',
      '2019年斑马邦TOP Sales',
      '累计服务合作40万+场赛事'
    ],
    wx: 'FgJyHIvFnQoBnW5UeU3BX8Q1Sc8D'
  },
  {
    icon: 'FiY9Wu3k3NQKTCMcmcE-ctAOPJll',
    name: '李光泽',
    mobile: '18659928276',
    desc: '不忘初心，砥砺前行。为每个赛事组织机构提供优质高效的真诚服务！',
    content: [
      '斑马邦华南区赛事合作商务主管',
      '2019年斑马邦TOP Sales',
      '累计服务合作40万+场赛事'
    ],
    wx: 'FgJyHIvFnQoBnW5UeU3BX8Q1Sc8D'
  },
  {
    icon: 'FsQsrk3WJ-M9IBiMxfZMvHKS7yYA',
    name: '成孝斌',
    mobile: '18121221333',
    desc: '不忘初心，砥砺前行。为每个赛事组织机构提供优质高效的真诚服务！',
    content: [
      '斑马邦华南区赛事合作商务主管',
      '2019年斑马邦TOP Sales',
      '累计服务合作40万+场赛事'
    ],
    wx: 'FjO25VZBbE4my5kGnCoRjekJYTsM'
  },
  {
    icon: 'FnEK6uEZWXTqaWE6al_J6wSY1k3X',
    name: '陈朗声',
    mobile: '15626568019',
    desc: '不忘初心，砥砺前行。为每个赛事组织机构提供优质高效的真诚服务！',
    content: [
      '斑马邦华南区赛事合作商务主管',
      '2019年斑马邦TOP Sales',
      '累计服务合作40万+场赛事'
    ],
    wx: 'FkVq1M1DudE9gI94UM2OnbFw4cdv'
  },
  {
    icon: 'FpbTAj2W0jSroGk1qJ9TLdE5vLdI',
    name: '蔡荣裕',
    mobile: '17750925055',
    desc: '不忘初心，砥砺前行。为每个赛事组织机构提供优质高效的真诚服务！',
    content: [
      '斑马邦华南区赛事合作商务主管',
      '2019年斑马邦TOP Sales',
      '累计服务合作40万+场赛事'
    ],
    wx: 'Ftj990I8xKKYLE4I996qZRRUEMy-'
  }
]
export default {
  name: 'BdAgent',
  data() {
    return {
      query: '',
      currentBd: {}
    }
  },
  mounted() {
    this.query = this.$route.query
    this.query.showWho = parseInt(this.query.showWho)
    let typeIndex = 0
    if (this.query.showWho === 0) {
      typeIndex = 0
    } else if (this.query.showWho === 1) {
      typeIndex = 1
    } else if (this.query.showWho === 2) {
      // typeIndex = 2 // 开发的BD 默认指向申雄
    } else if (this.query.showWho === 3) {
      // typeIndex = 3
    } else if (this.query.showWho === 4) {
      typeIndex = 4
    }
    this.currentBd = bdList[typeIndex]
    // 分享文案
    this.shareData = {
      title: '斑马邦赛事管家竭诚为您服务',
      link: this.getShareLink(),
      image: ImageFormat.squareImageView('FiyWzstnQ98KV_cqnYgPkCljISPc', 120),
      abstract: '扫码添加您的专属赛事管家，随时在线答疑'
    }
    this.wxShare(this.shareData)
  },
  methods: {
    imageView(hash, w, h, mode, format) {
      return ImageFormat.imageView(hash, w, h, mode, format)
    },
    getShareLink: function () {
      const arr = window.location.href.split('index.html')
      return arr[0] + 'index.html#/customer-service/bd-agent?dsbridge=1&bdRegion=' + this.query.bdRegion
    }
  }
}
</script>

<style lang="scss">
  body,html{
    background: #EDEDED !important;
  }
  .bm-bd-agent {
    position: relative;
    min-height: 100%;
    background: #EDEDED !important;
    .content{
      width: 340px;
      height: 462px;
      background-color: rgb(247, 247, 247);
      padding: 24px 22px;
      box-sizing: border-box;
      margin: 0 auto;
      position: absolute;
      top: 90px;
      left: 50%;
      transform: translate(-50%, 0);
      .top-info{
        .left{
          img{
            width: 55px;
            height: 55px;
          }
        }
        .right{
          margin-left: 10px;
          .house-manage{
            display: flex;
            align-items: center;
            .manage-name{
              font-size: 16px;
              color: #2B2B2B;
            }
            .manage-state{
              width: 50px;
              height: 18px;
              border: 1px solid #5261F9;
              color: #5261F9;
              border-radius: 2px;
              font-size: 10px;
              text-align: center;
              line-height: 22px;
              margin-left: 6px;
            }
          }
          .phone{
            text-align: center;
            font-size: 16px;
            color: #999999;
            margin-top: 7px;
          }
        }
      }
      .agent-tip{
        color: #999999;
        font-size: 20px;
        text-align: center;
        margin-top: 20px;
      }
    }
    .soft-code{
      width: 263px;
      height: 263px;
      margin: 12px auto 21px;
      text-align: center;
      img{
        width: 263px;
        height: 263px;
      }
    }
    .tips{
      text-align: center;
      color: #999999;
      font-size: 12px;
    }
    .footer-box{
      position: absolute;
      top: 655px;
      left: 50%;
      margin-left: -37px;
      padding-bottom: 15px;
      img{
        width: 74px;
        height: 24px;
        vertical-align: middle;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/customer-service/bd-agent2.vue